import { ReactNode, useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router';

import { CmsSubscribe } from 'api/cms';
import { showModal } from 'store/main/ducks/modal';
import { getParam, isUrlWithProtocol, pathWithParams } from 'utils//url';
import { RichError } from 'utils/RichError';
import { postJson } from 'utils/http';
import { trackError } from 'utils/trackError';
import { useTemporaryStorage } from 'utils/useTemporaryStorage';

type Props = {
  blockId: string;
  index: number;
  redirectUrl?: string;
  render: (arg0: { subscribe: () => void; isSubscribed: boolean }) => ReactNode;
};

const CmsSubscribeContainer = (props: Props) => {
  const dispatch = useDispatch();
  const { currentUser } = useSelector((state) => ({
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'currentUser' does not exist on type 'Def... Remove this comment to see the full error message
    currentUser: state.currentUser,
  }));
  const history = useHistory();
  const location = useLocation();
  const tmpIdFromParams = getParam(location, 'tmpId');
  const [disabled, setDisabled] = useState(false);
  const [tmpId, setTmpId] = useState('');
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [saveTemporaryStorage, temporaryStorage] =
    useTemporaryStorage<CmsSubscribe>(
      Array.isArray(tmpIdFromParams) ? tmpIdFromParams[0] : tmpIdFromParams
    );
  const redirectUrl =
    'redirectUrl' in temporaryStorage
      ? temporaryStorage.redirectUrl
      : props.redirectUrl;
  const subscribe = useCallback(() => {
    const showEmailSignupModal = (tmpIdToUse: string) => {
      const redirectTo = pathWithParams(
        `${window.location.pathname}${window.location.search}`,
        {
          tmpId: tmpIdToUse,
        }
      );
      dispatch(
        showModal('EMAIL_SIGNUP', {
          title: getText('Create an account on Idealist in order to subscribe'),
          redirectTo,
        })
      );
    };

    const loggedInVerifiedWithInfo = !!(
      currentUser &&
      currentUser.email !== null &&
      currentUser.emailVerified &&
      currentUser.firstName &&
      currentUser.lastName
    );

    if (loggedInVerifiedWithInfo) {
      const postBaseUrl = '/data/website/button-link-campaign-signup/';
      postJson(postBaseUrl + props.blockId, {
        index: props.index,
      })
        .then(() => {
          if (typeof redirectUrl === 'string') {
            if (isUrlWithProtocol(redirectUrl)) {
              window.location.href = redirectUrl;
              return;
            }

            history.push(
              redirectUrl.startsWith('/') ? redirectUrl : `/${redirectUrl}`
            );
          } else {
            setIsSubscribed(true);
          }
        })
        .catch((e) => {
          trackError(
            // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string' is not assignable to par... Remove this comment to see the full error message
            new RichError('Error subscribing in CMS block', JSON.stringify(e))
          );
        });
    } else {
      if (!disabled && !tmpId) {
        setDisabled(true);
        saveTemporaryStorage({
          CMS_SUBSCRIBE: {
            blockId: props.blockId,
            index: props.index,
            redirectUrl: props.redirectUrl,
          },
        }).then((createdTmpId) => {
          setDisabled(false);
          setTmpId(createdTmpId);
          return showEmailSignupModal(createdTmpId);
        });
      }

      showEmailSignupModal(tmpId);
    }
  }, [
    currentUser,
    disabled,
    dispatch,
    history,
    props.blockId,
    props.index,
    props.redirectUrl,
    redirectUrl,
    saveTemporaryStorage,
    tmpId,
  ]);
  useEffect(() => {
    if (
      'blockId' in temporaryStorage &&
      temporaryStorage.blockId === props.blockId &&
      temporaryStorage.index === props.index &&
      currentUser.emailVerified
    ) {
      subscribe();
    }
  }, [
    currentUser.emailVerified,
    props.blockId,
    props.index,
    subscribe,
    temporaryStorage,
  ]);
  return props.render({
    subscribe: subscribe.bind(this),
    isSubscribed,
  });
};

// eslint-disable-next-line import/no-default-export
export default CmsSubscribeContainer;
